import '@github/auto-check-element'
import '@github/details-dialog-element'
import '@github/details-menu-element'
import '@github/file-attachment-element'
import '@github/filter-input-element'
import '@github/g-emoji-element'
import '@github/include-fragment-element'
import '@github/image-crop-element'
import '@github/markdown-toolbar-element'
import '@github/remote-input-element'
import '@github/task-lists-element'
import '@github/text-expander-element'
import '@github/time-elements'
import '@github/typing-effect-element'
import '@primer/view-components'
import './github/fuzzy-list-element'
import './github/git-clone-help-element'
import './github/include-fragment-element-hacks'
import './github/notification-indicator-element'
import './github/notifications/focus_mode/notification-focus-indicator-element'
import './github/notifications/focus_mode/notification-focus-filters-element'
import './github/notifications/focus_mode/notification-focus-list-element'
import './github/notifications/focus_mode/notification-focus-list-item-element'
import './github/notifications/focus_mode/notification-focus-sidebar-element'
import './github/notifications/notifications-list-subscription-form-element'
import './github/notifications/notifications-team-subscription-form-element'
import './github/password-strength-element'
import './github/platform-toggle'
import './github/poll-include-fragment-element'
import './github/precise-time-ago-element'
import './github/slash-command-expander-element'
import './github/behaviors/ajax-error'
import './github/behaviors/ajax-loading'
import './github/behaviors/ajax-pagination'
import './github/behaviors/announce-pjax-loading'
import './github/behaviors/autocheck'
import './github/behaviors/autocomplete'
import './github/behaviors/autosearch-form'
import './github/behaviors/autoselect'
import './github/behaviors/autosubmit'
import './github/behaviors/avatar-reset-text'
import './github/behaviors/batch-deferred-content'
import './github/behaviors/billing-addons'
import './github/behaviors/blob-csv'
import './github/behaviors/blob-lines'
import './github/behaviors/bulk-actions'
import './github/behaviors/bundle-download-stats'
import './github/behaviors/button-outline'
import './github/behaviors/buttons'
import './github/behaviors/characters-remaining'
import './github/behaviors/check-all'
import './github/behaviors/clear-data-on-logout'
import './github/behaviors/clipboard-copy'
import './github/behaviors/code-nav'
import './github/behaviors/collector-api'
import './github/behaviors/color-modes'
import './github/behaviors/commenting/ajax'
import './github/behaviors/commenting/close'
import './github/behaviors/commenting/edit'
import './github/behaviors/commenting/focus'
import './github/behaviors/commenting/markdown'
import './github/behaviors/commenting/preview'
import './github/behaviors/commenting/reaction-suggestion'
import './github/behaviors/commits'
import './github/behaviors/confirm'
import './github/behaviors/company-name-input'
import './github/behaviors/company-owned'
import './github/behaviors/content-attachment'
import './github/behaviors/details'
import './github/behaviors/details-element'
import './github/behaviors/details-menu'
import './github/behaviors/disable-with'
import './github/behaviors/document-dropzone'
import './github/behaviors/encrypt'
import './github/behaviors/favicon'
import './github/behaviors/feature-preview-indicator'
import './github/behaviors/feature-preview-trigger'
import './github/behaviors/file-attachment'
import './github/behaviors/filter-input'
import './github/behaviors/filterable'
import './github/behaviors/firefox-label-hacks'
import './github/behaviors/fixed-offset-fragment-navigation-observer'
import './github/behaviors/flash'
import './github/behaviors/flash-observer'
import './github/behaviors/focus-delay'
import './github/behaviors/form-toggle'
import './github/behaviors/fuzzy-list'
import './github/behaviors/gfm'
import './github/behaviors/hash-change'
import './github/behaviors/header'
import './github/behaviors/hooks'
import './github/behaviors/hotkey-map'
import './github/behaviors/hovercards'
import './github/behaviors/html-validation'
import './github/behaviors/hydro-click-tracking'
import './github/behaviors/immediate-updates'
import './github/behaviors/include-fragment'
import './github/behaviors/indeterminate'
import './github/behaviors/jump-to-loader'
import './github/behaviors/keyboard-shortcuts'
import './github/behaviors/length-limited-input-with-warning'
import './github/behaviors/link-prefetch-viewed'
import './github/behaviors/member-search-filter'
import './github/behaviors/new-organization-name'
import './github/behaviors/notice'
import './github/behaviors/octolytics-pageview'
import './github/behaviors/octolytics-tracking'
import './github/behaviors/permalink'
import './github/behaviors/permission-menu-form'
import './github/behaviors/pjax'
import './github/behaviors/pjax-loader'
import './github/behaviors/pjax-timing'
import './github/behaviors/pjax/beforeunload'
import './github/behaviors/pjax/capture-keypresses'
import './github/behaviors/pjax/exceptions'
import './github/behaviors/pjax/head'
import './github/behaviors/pjax/history-navigate'
import './github/behaviors/pjax/link-prefetch'
import './github/behaviors/pjax/navigation'
import './github/behaviors/pjax/submit'
import './github/behaviors/print-popup'
import './github/behaviors/poll-include-fragment'
import './github/behaviors/proxy-site-reporting'
import './github/behaviors/quick-submit'
import './github/behaviors/quote-selection'
import './github/behaviors/reactions'
import './github/behaviors/remote-form'
import './github/behaviors/remote-pagination-element'
import './github/behaviors/removed-contents'
import './github/behaviors/render-editor'
import './github/behaviors/replace-remote-form'
import './github/behaviors/report-long-tasks'
import './github/behaviors/responsive-markdown-toolbar'
import './github/behaviors/responsive-underlinenav'
import './github/behaviors/saved-replies'
import './github/behaviors/scanning'
import './github/behaviors/segmented-nav'
import './github/behaviors/session-resume'
import './github/behaviors/side-navigation'
import './github/behaviors/site-notifications'
import './github/behaviors/site-search'
import './github/behaviors/size-to-fit'
import './github/behaviors/smooth-scroll-anchor'
import './github/behaviors/snippet-clipboard-copy'
import './github/behaviors/social'
import './github/behaviors/socket-channel'
import './github/behaviors/socket-channel-cache'
import './github/behaviors/sso-auto-replay'
import './github/behaviors/stale-session'
import './github/behaviors/statuses'
import './github/behaviors/sticky'
import './github/behaviors/sudo-required'
import './github/behaviors/suggesters/audit-log-suggester'
import './github/behaviors/suggesters/emoji-suggester'
import './github/behaviors/suggesters/issue-suggester'
import './github/behaviors/suggesters/mention-suggester'
import './github/behaviors/suggesters/slash-command-suggester'
import './github/behaviors/survey'
import './github/behaviors/sync-details-text'
import './github/behaviors/tab-container'
import './github/behaviors/tag-input'
import './github/behaviors/targetable-elements'
import './github/behaviors/task-list'
import './github/behaviors/team-members'
import './github/behaviors/text-suggester-element'
import './github/behaviors/timeline/marker'
import './github/behaviors/timeline/progressive'
import './github/behaviors/timeline/timeline-accessibility'
import './github/behaviors/timing-stats'
import './github/behaviors/toggler'
import './github/behaviors/tz-cookie'
import './github/behaviors/webauthn-get'
import './github/behaviors/unread-comments'
import './github/behaviors/unread-item-counter'
import './github/behaviors/updatable-content-observer'
import './github/behaviors/updatable-content-stale-object'
import './github/behaviors/upload-avatar'
import './github/behaviors/user-content'
import './github/behaviors/user-status-loader'
import './github/behaviors/visible-password-element'
import './github/behaviors/warn-unsaved-changes'
import './github/behaviors/will-transition-once'
import './github/behaviors/play-video'
import './github/issues/issue-link'
import './github/issues/labels'
import './github/issues/sidebar'

import '../../components/dynamic-components'

import {whenSeen} from './github/behaviors/dynamic-elements'

whenSeen('profile-pins', () => import('./github/profile/profile-pins-element'))
whenSeen('insights-graph', () => import('./github/insights/insights-graph'))
whenSeen('emoji-picker', () => import('./github/emoji-picker-element'))
whenSeen('edit-hook-secret', () => import('./github/behaviors/edit-hook-secret-element'))
whenSeen('insights-query', () => import('./github/insights/insights-query'))
whenSeen('series-table', () => import('@github/series-table-element'))
whenSeen('line-chart', () => import('@github/line-chart-element'))
